import { HTMLAttributes, SVGProps } from 'react';
import { Typography } from '../typography/typography';
import { twMerge } from 'tailwind-merge';
import { ReactNode } from '@tanstack/react-router';

export type PageHeaderSpecProps = {
  text: string;
  icon?: (props: SVGProps<SVGSVGElement>) => ReactNode;
  value?: string;
} & HTMLAttributes<HTMLDivElement>;

export function PageHeaderSpec(props: PageHeaderSpecProps) {
  const { text, icon: Icon, value, className, ...rest } = props;

  return (
    <div
      className={twMerge('flex flex-row items-center space-x-4', className)}
      {...rest}
    >
      {Icon && <Icon className="min-w-16 w-16 h-16 fill-grayscale400" />}
      <Typography variant="body-xs" className="text-grayscale400">
        {text}
      </Typography>

      {value && (
        <Typography
          variant="body-xs"
          weight="medium"
          className="text-grayscale400"
        >
          {value}
        </Typography>
      )}
    </div>
  );
}
